import styled from 'styled-components';

export const TagLine = styled.p`
  font-weight: 400;
  line-height: 1.25;
`;
